

import { Vue, Options } from 'vue-class-component'

@Options({
    methods: {
        logout_user: function () {
            localStorage.removeItem('access')
            localStorage.removeItem('refresh')
            localStorage.removeItem('userusername')
            localStorage.removeItem('wid');
            localStorage.removeItem('wname');
            localStorage.setItem('status', 'false')
            this.$router.push('/auth')
        },
        check_user_logout: function () {
            let status = localStorage.getItem('status');
            if (status == 'loggedin') {
                this.$router.push('/logout');
            }
            else {
                this.$router.push('/auth');
            }
        },
    },
    beforeMount() {
        this.check_user_logout()
    }
})

export default class Logout extends Vue { }

